const emailReg = /^[A-Z a-z 0-9_.-]+@{1}[A-Z a-z 0-9_.-]+\.{1}[A-Z a-z 0-9_.-]+/;

export default emailReg